export const lightTheme = {
  bgcol: "#fc7462",
  txtcol: "#fc7462",
};
export const darkTheme = {
  bgcol: "#99c1bb",
  txtcol: "#99c1bb",
};
